import { render, staticRenderFns } from "./DataValidationModal.vue?vue&type=template&id=1f4bbca8&"
import script from "./DataValidationModal.vue?vue&type=script&lang=js&"
export * from "./DataValidationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports